import { cn } from '@/utils/cn';

interface StatusIndicatorProps {
  status: 'healthy' | 'degraded' | 'down' | 'success' | 'warning' | 'error' | 'neutral';
  label?: string;
  className?: string;
}

const colors = {
  healthy: 'bg-success-500',
  success: 'bg-success-500',
  degraded: 'bg-warning-500',
  warning: 'bg-warning-500',
  down: 'bg-danger-500',
  error: 'bg-danger-500',
  neutral: 'bg-neutral-500',
};

export function StatusIndicator({ status, label, className }: StatusIndicatorProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="relative flex h-2.5 w-2.5">
        {(status === 'healthy' || status === 'success') && (
          <span className={cn('absolute inline-flex h-full w-full animate-ping rounded-full opacity-75', colors[status])} />
        )}
        <span className={cn('relative inline-flex h-2.5 w-2.5 rounded-full', colors[status])} />
      </span>
      {label && <span className="text-sm text-neutral-700 dark:text-neutral-300">{label}</span>}
    </div>
  );
}
